module.exports = "/images/social-media-white.svg?ac609f3007bac6ba275b5826dedcc438";